import React from "react";

import Box from "../Box";

const Special1 = props => {
  return (
    <section className="hp__block hp__block--special  hp__block--special--1 container-fluid">
      <div className="row">
        <Box
          {...props}
          id="b1"
          type="pile"
          settings={props.settings.b1}
          classes="hp__box--main col-xs-12 col-sm-9"
          thumbnailHeight="825"
        />
        <Box
          {...props}
          id="b2"
          type="partner"
          settings={props.settings.b2}
          classes="hp__box--column col-xs-12 col-sm-3"
        />
      </div>
    </section>
  );
};

export default Special1;
